<template>
  <div class="gs-checkout-builder-step gs-checkout-billing-step">
    <div class="gs-checkout-billing-step__switch-row">
      <div>
        <h3>{{ $t('frontend_checkout_links_step7_skip_billing_address') }}</h3>
        <p>Configure which information free-offer buyers can skip. Paid offers keep the required payment details.</p>
      </div>
      <gd-toggle
        v-model="localModel.has_skip_fields"
        :value="localModel.has_skip_fields"
        :aria-label="$t('frontend_checkout_links_step7_skip_billing_address')"
      />
    </div>

    <section v-if="localModel.has_skip_fields" class="gs-checkout-billing-step__table-card">
        <div class="gs-checkout-billing-step__table-head">
          <span>Price point</span>
          <span>{{ $t('frontend_skip_bill_info') }}</span>
          <span>{{ $t('frontend_skip_tos') }}</span>
          <span>{{ $t('frontend_skip_phone') }}</span>
        </div>

        <div class="gs-checkout-billing-step__rows">
          <div v-for="pricePoint in pricepointsForProjectionsFiltered" :key="pricePoint.id"
            class="gs-checkout-billing-step__row">
              <strong>{{ pricePoint.name }}</strong>

              <div>
                <span v-if="pricePoint.price > 0" class="gs-checkout-billing-step__na">Not available</span>
                <template v-else>
                  <gd-toggle
                    v-model="localModel.skip_field_arr[localModelPricePointIndex(pricePoint.id)].skip_billing_info"
                    :value="localModel.skip_field_arr[localModelPricePointIndex(pricePoint.id)].skip_billing_info"
                    :aria-label="`Skip billing information for ${pricePoint.name}`" />
                </template>
              </div>

              <div>
                <span v-if="pricePoint.price > 0" class="gs-checkout-billing-step__na">Not available</span>
                <template v-else>
                  <gd-toggle
                    v-model="localModel.skip_field_arr[localModelPricePointIndex(pricePoint.id)].skip_terms_or_service"
                    :value="localModel.skip_field_arr[localModelPricePointIndex(pricePoint.id)].skip_terms_or_service"
                    :aria-label="`Skip terms for ${pricePoint.name}`" />
                </template>
              </div>
              <div>
                <span v-if="pricePoint.price > 0" class="gs-checkout-billing-step__na">Not available</span>
                <template v-else>
                  <gd-toggle v-model="localModel.skip_field_arr[localModelPricePointIndex(pricePoint.id)].skip_phone"
                    :value="localModel.skip_field_arr[localModelPricePointIndex(pricePoint.id)].skip_phone"
                    :aria-label="`Skip phone for ${pricePoint.name}`" />
                </template>
              </div>
          </div>
        </div>
    </section>

    <div v-else class="gs-checkout-billing-step__empty">
      Standard billing, terms, and phone requirements remain enabled.
    </div>
  </div>
</template>

<script>

export default {
  name: 'BillingAdressStep',
  components: {
  },
  props: {
    model: {
      required: true,
    },
    pricepointTabs: {
      required: true,
    },
    selectPricePoint: {
      required: true,
    },
    pricepointsForProjections: {
      required: true,
    },
    projectionsPricePointsTab: {
      required: true,
    },
    handleProjectionPricePointTabChange: {
      required: true,
    },
  },

  data() {
    return {
      askForPasswordType: [
        {
          id: 1,
          title: this.$t('frontend_ask_for_pass_start'),
          description: '',
        },
        {
          id: 0,
          title: this.$t('frontend_ask_for_pass_end'),
          description: '',
        },
      ],
      askPasswordValue: 1,
      test: false,
      localModel: this.model,
      pricePointTabsEnabled: [],
      skip_field_arr: [],
      pricepointsForProjectionsFiltered: [],
      // ask_for_password_select: 0,
      ask_for_password_select: 1,
      projectionsPPointsTab: this.projectionsPricePointsTab,
    };
  },
  computed: {
    movePasswordFieldSwith() {
      let hasPasswordEnable = false;
      for (let i = 0; i < this.localModel.skip_field_arr.length; i++) {
        if (this.localModel.skip_field_arr[i].ask_for_password === true) {
          hasPasswordEnable = true;
        }
      }
      return hasPasswordEnable;
    },
  },
  watch: {
    localModel: {
      deep: true,
      handler() {
        this.$emit('updateModel', this.localModel);
      },
    },
  },

  async created() {


    if (this.localModel.checkout_link_page_options.move_password_to_last_step) {
      this.askPasswordValue = 0;
    }

    const enabledPricePoints = this.selectPricePoint.filter((pricePoint) => {
      return pricePoint.enabled;
    });

    const enabledPricePointIdArr = enabledPricePoints.map((point) => {
      return point.id;
    });

    for (let i = 0; i < enabledPricePoints.length; i++) {
      this.pricePointTabsEnabled.push({
        title: enabledPricePoints[i].name,
        value: `price_point_${enabledPricePoints[i].id}`,
      });
    }

    for (let i = 0; i < this.pricepointsForProjections.length; i++) {
      if (enabledPricePointIdArr.indexOf(this.pricepointsForProjections[i].id) != -1 && this.pricepointsForProjections[i].price == 0) {
        this.pricepointsForProjectionsFiltered.push(
          this.pricepointsForProjections[i]
        );
      }
    }

    if (this.pricepointsForProjectionsFiltered.length)
      this.projectionsPPointsTab = `price_point_${this.pricepointsForProjectionsFiltered[0].id}`;
  },

  methods: {
    changeAskPasswordType(value) {
      this.askPasswordValue = value;
      this.localModel.checkout_link_page_options.move_password_to_last_step = value == 1 ? false : true;
    },

    localModelPricePointIndex(pricePointId) {
      return this.localModel.skip_field_arr.findIndex(
        (pricepoint) => pricepoint.id == pricePointId
      );
    },

    validate() {
      const isValid = true;
      this.$emit('on-validate', isValid);
      return isValid;
    },
  },
};
</script>

<style scoped>
.gs-checkout-billing-step {
  display: grid;
  gap: 18px;
}

.gs-checkout-billing-step__switch-row,
.gs-checkout-billing-step__table-card,
.gs-checkout-billing-step__empty {
  padding: 20px;
  background: #fff;
  border: 1px solid var(--gs-border, #e2e8f0);
  border-radius: 12px;
}

.gs-checkout-billing-step__switch-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.gs-checkout-billing-step h3,
.gs-checkout-billing-step p {
  margin: 0;
}

.gs-checkout-billing-step h3 {
  color: var(--gs-foreground, #182230);
  font-size: 14px;
  font-weight: 800;
}

.gs-checkout-billing-step p,
.gs-checkout-billing-step__empty {
  color: var(--gs-muted-foreground, #667085);
  font-size: 12px;
  line-height: 1.5;
}

.gs-checkout-billing-step p {
  margin-top: 4px;
}

.gs-checkout-billing-step__table-head,
.gs-checkout-billing-step__row {
  display: grid;
  align-items: center;
  grid-template-columns: minmax(220px, 1fr) repeat(3, 150px);
  gap: 12px;
}

.gs-checkout-billing-step__table-head {
  padding: 0 8px 12px;
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: .045em;
  text-transform: uppercase;
}

.gs-checkout-billing-step__table-head span:not(:first-child),
.gs-checkout-billing-step__row > div {
  text-align: center;
}

.gs-checkout-billing-step__rows {
  max-height: 320px;
  overflow-y: auto;
  border-top: 1px solid var(--gs-border, #e2e8f0);
}

.gs-checkout-billing-step__row {
  min-height: 58px;
  padding: 9px 8px;
  border-bottom: 1px solid var(--gs-border, #e2e8f0);
}

.gs-checkout-billing-step__row strong {
  color: var(--gs-foreground, #182230);
  font-size: 12px;
  font-weight: 700;
}

.gs-checkout-billing-step__na {
  display: inline-block;
  padding: 4px 7px;
  color: #94a3b8;
  font-size: 9px;
  font-weight: 700;
  background: #f1f5f9;
  border-radius: 999px;
}

.gs-checkout-billing-step__empty {
  background: #f8fafc;
}
</style>
